import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// "Link each tag chip to its tag page" — carried by DynamicAppTagListElement
// (stringArray fields, hashtags being the canonical case). Defaults to Yes:
// hashtag chips have always navigated to the tag page on the legacy
// elements, and the generic element keeps that behavior parity.
export default class LinkTags extends BaseOption {
  static userInterfaceComponent = {
    label: "Link Tags",
    component: inspectorTools.RADIO_BAR,
    props: {
      iconSize: 24,
      options: [
        {
          label: "Yes",
          value: true,
        },
        {
          label: "No",
          value: false,
        },
      ],
    },
  };

  static defaultValue = true;
}
